import Vue from "vue";
import toast from '#/toast';
let _toast = Vue.extend(toast);
Vue.prototype.$flyio_toast = (data)=>{
	//动态加载提示框插件
    let _sju = {};
    if(data){
    	_sju = {
			msg:data.msg,
			time:data.time
		};
    }else{
    	_sju = {
			msg:"我是提示框",
			time:1500
		};
    }
	let _node = document.createElement("div");
	document.body.appendChild(_node);
	let node = new _toast().$mount(_node);
	node._self.showFu(_sju);
};


// WEBPACK FOOTER //
// ./src/AppConfigH5/tips.js